import { useEffect, useRef } from "react"
import anime, { AnimeInstance, AnimeParams } from "animejs"

export const useSingleEase = (
    show: boolean,
    timeIn = 500,
    timeOut = 500,
    animeOptions: {
        ignoreZ?: boolean
        showAtFirst?: boolean
        blurIn?: boolean
        blurOut?: boolean
        in?: AnimeParams
        out?: AnimeParams
    } = {}
) => {
    const animeRef = useRef<AnimeInstance>()
    const ref = useRef<HTMLDivElement>(null)

    useEffect(() => {
        if (animeRef.current) animeRef.current.pause()
        if (show) {
            if (ref.current) ref.current.style.display = ""
            const animeConfig = {
                targets: ref.current,
                easing: "easeOutCubic",
                duration: timeIn,
                update: (anim) => {
                    const ele = ref.current
                    if (!ele || !animeOptions.blurIn) return
                    ele.style.filter = `blur(${
                        8 - 8 * (anim.progress / 100)
                    }px)`
                },
                complete: () => {
                    if (ref.current) ref.current.style.pointerEvents = "all"
                },
                opacity: 1,
                ...animeOptions.in,
            } as anime.AnimeParams
            if (!animeOptions.ignoreZ) animeConfig.translateZ = [0, 0]
            animeRef.current = anime(animeConfig)
        } else {
            const animeConfig = {
                targets: ref.current,
                easing: "easeInCubic",
                duration: timeOut,
                update: (anim) => {
                    const ele = ref.current
                    if (!ele || !animeOptions.blurOut) return
                    ele.style.filter = `blur(${8 * (anim.progress / 100)}px)`
                },
                opacity: 0,
                ...animeOptions.out,
                begin: () => {
                    if (ref.current) ref.current.style.pointerEvents = "none"
                },
                complete: () => {
                    if (ref.current) ref.current.style.display = "none"
                },
            } as anime.AnimeParams
            if (!animeOptions.ignoreZ) animeConfig.translateZ = [0, 0]
            animeRef.current = anime(animeConfig)
        }
    }, [show])

    useEffect(() => {
        if (ref.current && !animeOptions.showAtFirst)
            ref.current.style.display = "none"
    }, [])

    return ref
}
